export default "__VITE_ASSET__rY2EqTL1__"